<template>
  <div class="bh-page">
    <div class="container">
      <div class="text-center bh-header">
        <h3 class="bh-title">{{ $t("BHTitle") }}</h3>
        <p class="bh-subtitle">
          {{ $t("BHSubtitle1") }}<br />
          {{ $t("BHSubtitle2") }}
        </p>
      </div>

      <div class="bh-modules">
        <div class="bh-modules-list" ref="modulesRoot">
          <div
            class="bh-module bh-module-active"
            :class="{ 'bh-module-open': openModule === 'inspection' }"
            @click="ToggleModule('inspection')"
          >
            <div class="bh-module-title">{{ $t("BHInspection") }}</div>
          </div>

          <div class="bh-stages" v-if="openModule === 'inspection'" @click.stop>
            <button
              type="button"
              class="bh-stage"
              @click="SelectStage('notified')"
            >
              <span>{{ $t("BHStageNotified") }}</span>
            </button>
            <button
              type="button"
              class="bh-stage"
              @click="SelectStage('24h')"
            >
              <span>{{ $t("BHStage24h") }}</span>
            </button>
            <button
              type="button"
              class="bh-stage"
              @click="SelectStage('criminal')"
            >
              <span>{{ $t("BHStageCriminal") }}</span>
            </button>
          </div>

          <div
            class="bh-module bh-module-active"
            @click="GoInspection('profilaktika')"
          >
            <div class="bh-module-title">{{ $t("BHProphylactic") }}</div>
          </div>

          <div
            class="bh-module bh-module-active"
            @click="GoInspection('muloqot')"
          >
            <div class="bh-module-title">{{ $t("BHCommunication") }}</div>
          </div>
        </div>
      </div>

      <!-- Nazorat organi / Tadbirkor qismini tanlash modali commentga olindi.
           Endi bosqich bosilganda to'g'ridan-to'g'ri 'control' qismiga o'tiladi.
      <b-modal
        v-model="createModal"
        hide-footer
        size="lg"
        no-close-on-backdrop
        :title="$t('BHCreateChoiceTitle')"
        centered
      >
        <div class="bh-create-choice">
          <button
            type="button"
            class="bh-create-btn"
            @click="GoCreate('control')"
          >
            + {{ $t("BHCreateControlPart") }}
          </button>
          <button
            type="button"
            class="bh-create-btn"
            @click="GoCreate('contractor')"
          >
            + {{ $t("BHCreateContractorPart") }}
          </button>
        </div>
      </b-modal>
      -->



    

      


     
    </div>
  </div>
</template>

<script>
export default {
  name: "BiznesHimoya",
  data() {
    return {
      downloading: false,
      openModule: null,
      createModal: false,
      selectedStage: "",
    };
  },
  mounted() {
    document.addEventListener("mousedown", this.HandleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.HandleOutsideClick);
  },
  methods: {
    ToggleModule(key) {
      this.openModule = this.openModule === key ? null : key;
    },
    SelectStage(stage) {
      this.$emit("select-stage", stage);
      this.selectedStage = stage;
      // Modal (control/contractor tanlovi) commentga olindi — to'g'ridan-to'g'ri 'control' qismiga o'tamiz.
      this.GoCreate("control");
    },
    GoCreate(part) {
      this.createModal = false;
      this.$router.push({
        name: "InspectionBookNewEdit",
        params: { id: 0 },
        query: { stage: this.selectedStage, part: part },
      });
    },
    GoInspection(kind) {
      const name = kind === "profilaktika" ? "QrProfilaktika" : "QrMuloqot";
      this.$router.push({ name: name }).catch(() => {});
    },
    HandleOutsideClick(event) {
      if (!this.openModule) return;
      const root = this.$refs.modulesRoot;
      if (root && !root.contains(event.target)) {
        this.openModule = null;
      }
    },
    PrintPage() {
      window.print();
    },

    async DownloadPNG() {
      this.downloading = true;
      const src = "/images/biznes-himoya-badge.png";

      const toCanvas = (scale) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            const c = document.createElement("canvas");
            c.width = img.naturalWidth * scale;
            c.height = img.naturalHeight * scale;
            const ctx = c.getContext("2d");
            ctx.scale(scale, scale);
            ctx.drawImage(img, 0, 0);
            resolve(c.toDataURL("image/png"));
          };
          img.onerror = reject;
          img.src = src + "?v=" + Date.now();
        });

      const save = (href, name) => {
        const a = document.createElement("a");
        a.href = href;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };

      try {
        // Rasm 1
        save(await toCanvas(1), "biznes-himoya-badge.png");
        await new Promise((r) => setTimeout(r, 500));
        // Rasm 2 - yuqori sifat
        save(await toCanvas(2), "biznes-himoya-badge-hd.png");
      } catch {
        save(src, "biznes-himoya-badge.png");
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.bh-page {
  min-height: 100vh;
  background: #fff;
  padding-bottom: 60px;
}

.bh-header {
  padding: 40px 0 20px;
}

.bh-title {
  font-size: 26px;
  font-weight: 700;
  color: #1a2e60;
  margin-bottom: 12px;
}

.bh-subtitle {
  font-size: 15px;
  color: #555;
  line-height: 1.7;
}

.bh-modules {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.bh-modules-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 560px;
}

.bh-module {
  position: relative;
  background: #fff;
  border: 1.5px solid #e2e6ee;
  border-radius: 14px;
  padding: 22px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.bh-module-title {
  font-size: 18px;
  font-weight: 700;
  color: $primary-dark;
}

.bh-module-active {
  cursor: pointer;

  &:hover {
    border-color: $primary;
  }

  &.bh-module-open {
    border-color: $primary;
    box-shadow: 0 6px 20px rgba(63, 117, 254, 0.15);
  }
}

.bh-module-soon {
  background: #f7f9ff;
  border-style: dashed;
  color: #6b7280;

  .bh-module-title {
    color: #6b7280;
  }
}

.bh-soon-badge {
  background: #eef2ff;
  color: #3F75FE;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 999px;
  letter-spacing: 0.3px;
}

.bh-stages {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 560px;
  margin: -4px auto 0;
  padding: 16px 28px 4px;
  z-index: 3;
}

.bh-stage {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  background: #fff;
  border: 1.5px solid $primary;
  color: $primary-dark;
  border-radius: 12px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  box-shadow: 0 4px 14px rgba(63, 117, 254, 0.12);
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;

  & > span:first-child {
    white-space: normal;
    word-break: break-word;
    flex: 1;
  }

  .bh-soon-badge {
    flex-shrink: 0;
  }

  &:hover {
    transform: translateX(4px);
  }
}

.bh-stage-soon {
  background: #f7f9ff;
  border-style: dashed;
  color: #6b7280;
  box-shadow: none;
  cursor: not-allowed;

  &:hover {
    transform: none;
  }
}

.bh-create-choice {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 12px 4px 4px;
}

.bh-create-btn {
  background: $primary;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 18px 22px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(63, 117, 254, 0.18);
  transition: background 0.15s ease, transform 0.15s ease;

  &:hover {
    background: $primary-dark;
    transform: translateY(-1px);
  }
}

@media (min-width: 576px) {
  .bh-create-choice {
    flex-direction: row;
  }
  .bh-create-btn {
    flex: 1;
  }
}

@media (max-width: 991px) {
  .bh-stage {
    white-space: normal;
  }
}

/* 2-column row */
.bh-row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 28px;
  margin-top: 20px;
}

.bh-col-badge {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
}

.bh-col-soon {
  flex: 0 0 auto;
  width: 360px;
  display: flex;
  align-items: stretch;
}

.bh-badge-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 24px 28px 16px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
}

.bh-shield-svg {
  width: 260px;
  height: auto;
  display: block;
}

.bh-scan-label {
  margin-top: 10px;
  text-align: center;
  line-height: 1.6;
}

.bh-scan-text {
  font-size: 11px;
  color: #888;
  letter-spacing: 0.5px;
}

.bh-scan-url {
  display: block;
  font-size: 14px;
  color: #22a366;
  font-weight: 600;
}

/* Coming soon */
.bh-coming-soon {
  width: 100%;
  text-align: center;
  padding: 36px 28px;
  background: linear-gradient(135deg, #f8faff 0%, #eef2ff 100%);
  border: 1.5px solid #dde5ff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bh-cs-icon {
  margin-bottom: 14px;
}

.bh-cs-tag {
  display: inline-block;
  background: #3F75FE;
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 14px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  margin-bottom: 14px;
}

.bh-cs-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a2e60;
  margin-bottom: 10px;
}

.bh-cs-desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0;
}

.bh-actions {
  margin-top: 32px;
  gap: 16px;
}

.bh-btn-print {
  display: inline-flex;
  align-items: center;
  background: #22c55e;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #16a34a; }
}

.bh-btn-download {
  display: inline-flex;
  align-items: center;
  background: white;
  color: #374151;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
  &:hover { border-color: #3f75fe; color: #3f75fe; }
  &:disabled { opacity: 0.6; cursor: default; }
}

.bh-hint {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 12px;
}

@media (max-width: 768px) {
  .bh-row {
    flex-direction: column;
  }
  .bh-col-badge {
    align-items: center;
    width: 100%;
  }
  .bh-btn-download {
    width: 100%;
    justify-content: center;
  }
}

@media print {
  .bh-page > .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bh-header,
  .bh-steps,
  .bh-actions,
  .bh-hint {
    display: none !important;
  }
  .bh-badge-wrapper {
    border: none;
    box-shadow: none;
    padding: 0;
  }
  .bh-shield-svg {
    width: 180mm;
    height: auto;
  }
  .bh-scan-label {
    display: none;
  }
}
</style>
